<script setup>
import { UserIcon } from '@heroicons/vue/24/outline'
const props = defineProps({
  theme: {
    type: Object,
    default: () => ({})
  },
  showDetails: {
    type: Boolean,
    default: true
  }
})

const tech = useTech()
const techTheme = useTechTheme()
const currentTheme = computed(() => techTheme.lowestLevelTheme?.value)

const badgeTheme = computed(() => ({
  avatarContainer: currentTheme.value?.bgColorGradientTransparent || 'bg-gradient-to-r from-mint to-cerulean dark:bg-dark-charcoal dark:bg-none',
  avatarIcon: 'text-dark-gunmetal dark:text-body-gray',
  name: 'text-quartz dark:text-white',
  occupation: 'text-body-gray',
  ...props.theme
}))

const user = useUser()
</script>

<template>
  <div v-if="!user.isGuest">
    <div
      class="flex size-20 items-center justify-center overflow-hidden rounded-xl dark:bg-dark-charcoal"
      :class="[{'!bg-gradient-to-r !from-nuxt-green !to-nuxt-green' : tech.id ==='nuxt', '!from-angular-pink !to-angular-pink' : tech.id ==='angular'}, badgeTheme?.avatarContainer]">
      <img
        v-if="user.data.avatar"
        :src="user.data.avatar"
        class="size-full object-cover object-center"
        :alt="user.name">
      <slot
        v-else
        :user="user">
        <UserIcon
          :class="[badgeTheme?.avatarIcon, {'dark:text-white' : tech.id ==='nuxt'}]"
          :alt="user.name"
          class="max-w-16" />
      </slot>
    </div>
    <template v-if="showDetails">
      <p
        class="mt-4 text-xl font-semibold"
        :class="badgeTheme?.name">
        {{ user.name || 'You' }}
      </p>
      <p
        v-if="user.data.occupation"
        class="mt-1 text-sm font-light"
        :class="badgeTheme?.occupation">
        {{ user.data.occupation }}
      </p>
    </template>
  </div>
</template>
